(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name commons.directive:jqDatePickerOptions
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="commons">
       <file name="index.html">
        <jq-date-picker-options></jq-date-picker-options>
       </file>
     </example>
   *
   */
  angular
    .module('commons')
    .directive('jqDatePickerOptions', jqDatePickerOptions);

  function jqDatePickerOptions(EventManagerService,CommonMasterData, $timeout,CommonDataModel) {
    return {
      restrict: 'A',
      scope: {
          isDisabled: '='
      },
      require: 'ngModel',
      replace: false,
      controllerAs: 'jqDatePickerOptions',
      controller: function () {
        var vm = this;
        vm.name = 'jqDatePickerOptions';
      },
      link: function (scope, element, attrs, ctrl) {
          /* jshint unused:false */
          /* eslint "no-unused-vars": [2, {"args": "none"}] */
          var picker = angular.element(element);

          var changeDatePickerOptions = function(newOption){
              var options = picker.datepicker( "option");
              options = angular.extend(options,newOption);
              picker.datepicker( "option",  options );
              picker.datepicker("refresh");
          };

          CommonDataModel.appWeekStartDay.subscribe(function (startDate) {
              changeDatePickerOptions(startDate);
          });


          EventManagerService.registerEventListener(EventManagerService.EVENT.DATEPICKER_OPTIONS_CHANGED, function (newOption){
              if(angular.isDefined(newOption.target)){
                  if(ctrl.$name == newOption.target){
                      delete  newOption.target;
                      changeDatePickerOptions(newOption);
                  }
              }else{
                  changeDatePickerOptions(newOption);
              }
          });

          var settings = {
              dateFormat : 'dd/mm/yy',
              firstDay: 1
          };

          if(attrs.isInline === undefined || attrs.isInline!=="true"){
              settings.buttonImage = "images/calendericon.png";
              settings.changeMonth = true;
              settings.changeYear =  true;
              settings.buttonImageOnly = true;
              settings.showOn = "button";
              settings.buttonText = "Select date";
          }
          
          if(attrs.isInline=="true" && attrs.name=="crewProfileDateOfBirth"){
        	  settings.buttonImage = "images/calendericon.png";
              settings.changeMonth = true;
              settings.changeYear =  true;
              settings.buttonImageOnly = true;
              settings.showOn = "button";
              settings.buttonText = "Select date";
              settings.yearRange = "-100:+0";
          }

          var opt = settings;
          opt.firstDay = CommonMasterData.getAppWeekStartDay();

          if (angular.isDefined(attrs.jqDatePickerOptions)){
              opt = angular.extend(settings,scope.$parent.$eval(attrs.jqDatePickerOptions));
          }

          opt.onSelect = function (dateText) {
              ctrl.$setViewValue(dateText);
              scope.$apply();
          };

          picker.datepicker(opt);
          picker.datepicker('setDate', ctrl.$modelValue);

          $timeout(function() {
              scope.$apply();
              if (scope.isDisabled) {
                  picker.datepicker( "option", "disabled", true );
                  picker.datepicker("refresh");
              }
          },0);

      }
    };
  }
}());
